import Config from '../../../config/Config'
import { map, mergeMap, catchError, withLatestFrom } from 'rxjs/operators'
import { of } from 'rxjs'
import { ajax } from 'rxjs/ajax'
import * as actions from '../actions'
import { jwtSelector } from '../../auth/selectors'
import { ofType } from 'redux-observable'
import { rootCatchError } from '../../../lib/Utils'
import queryString from '@promoboxx/query-string-babel'

export const getStatsObservable = ([action, state]) => {
  const jwt = jwtSelector(state) || action.payload.jwt
  const { statsType, params = {} } = action.payload

  if (!jwt) {
    throw new Error('Non-existent JWT auth')
  }

  if (!statsType) {
    throw new Error('Stats type is required')
  }

  if ((!params.brandIds && !params.retailerIds) || (params.brandIds && params.retailerIds)) {
    throw new Error('Brand or Retailer ID(s) must be provided, not both')
  }

  const { brandIds, retailerIds, filterIds } = params
  let allParams = {}
  if (brandIds) {
    allParams.brand_ids = brandIds
  }
  if (retailerIds) {
    allParams.retailer_ids = retailerIds
  }
  if (filterIds) {
    allParams.filter_ids = filterIds
  }

  let queryParams = ''
  if (allParams) {
    queryParams = `?${queryString.stringify(allParams, { arrayFormat: 'comma' })}`
  }

  const settings = {
    method: 'GET',
    responseType: 'json',
    headers: {
      'Authorization': jwt,
      'Content-Type': 'application/json',
    },
    url: `${Config.SERVICE_BASE}/stats/v1/stats/${statsType}${queryParams}`,
  }

  return ajax(settings).pipe(
    map((payload) => {
      return {
        type: actions.GET_STATS_FULFILLED,
        payload: {
          params: action.payload,
          response: payload.response,
        },
      }
    }),
    catchError((payload) => {
      return of({
        type: actions.GET_STATS_REJECTED,
        payload: {
          params: action.payload,
          response: payload.response,
        },
      })
    }),
  )
}

export const getStatsEpic = (action$, state$) => {
  return action$.pipe(
    ofType(actions.GET_STATS),
    withLatestFrom(state$),
    mergeMap(getStatsObservable),
    rootCatchError(actions.GET_STATS_REJECTED),
  )
}
